// import { Injectable } from '@angular/core';

// @Injectable({
//     providedIn: 'root',
// })
// export class ThemeService {
//     theme: any;
//     themes: Array<any>;

//     constructor() {
//         this.themes = [
//             { 'name': 'Black & White', 'code': 'blackwhite' },
//             // { 'name': 'Professional', 'code': 'professional' },
//             // { 'name': 'Seaside', 'code': 'seaside' },
//             { 'name': 'Corporate', 'code': 'corporate' },
//             // { 'name': 'Wordpress', 'code': 'wordpress' },
//             // { 'name': 'Vintage Charm', 'code': 'vintageCharm' },
//             { 'name': 'Purple Cube', 'code': 'purpleCube' },
//         ]
        
//          this.theme = this.themes[0];
//     }

//     changeTheme(theme: any): void {
//         this.theme = theme;
//     }

//     setTheme(code: string): void {
//         for (let i: number = 0; i < this.themes.length; i++) {
//             if(this.themes[i].code == code) {
//                 this.theme = this.themes[i];
//             }
//         }
//     }
// }

import { Injectable } from '@angular/core';
 
@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    theme: any;
    themes: Array<any>;
 
    constructor() {
        this.themes = [
            { 'name': 'Black & White', 'code': 'blackwhite' },
            { 'name': 'Corporate', 'code': 'corporate' },
            { 'name': 'Purple Cube', 'code': 'purpleCube' },
        ];
 
        this.theme = this.themes[0]; // default theme
 
        this.loadTheme(); // Load the saved theme from localStorage
    }
 
    changeTheme(theme: any): void {
        this.theme = theme;
        localStorage.setItem('selectedTheme', theme.code);
        this.applyTheme(theme.code);
    }
 
    setTheme(code: string): void {
        const selectedTheme = this.themes.find(t => t.code === code);
        if (selectedTheme) {
            this.theme = selectedTheme;
            this.applyTheme(selectedTheme.code);
        }
    }
 
    private loadTheme(): void {
        const savedThemeCode = localStorage.getItem('selectedTheme');
        if (savedThemeCode) {
            this.setTheme(savedThemeCode);
        } else {
            this.applyTheme(this.theme.code); // Apply default theme if no theme is saved
        }
    }
 
    private applyTheme(themeCode: string): void {
        document.documentElement.className = themeCode;
    }
}